import { jsx as _jsx } from "react/jsx-runtime";

function CanonicalLink({
  href,
  rel = 'canonical'
}) {
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    href: href.replace(/\/$/, ''),
    "data-test-id": `${rel}-link`
  });
}

export default CanonicalLink;